import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import { RegionPage } from "@/components/calv/RegionPage";

export const Route = createFileRoute("/en/regions/schweinfurt")({
  head: () => {
    const h = pageHead("region:schweinfurt", "en");
    return { meta: h.meta, links: h.links };
  },
  component: () => <RegionPage slug="schweinfurt" locale="en" />,
});
